"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.delete.tooltip': 'Eliminar conversación',
    'conversations.delete.confirm': '¿Estás seguro de que quieres eliminar "{title}"? Esta acción no se puede deshacer.',
};
